export default {
  INIT: (state) => {
    state.loggedIn = false;
  },
  SET_LOGGED_IN(state, value) {
    state.loggedIn = value;
  },
};
